import { InputText } from "primereact/inputtext";
import "./Vendor.css";

export default function SearchInput({ value, onChange }) {
  const handleClear = () => {
    onChange({ target: { value: "" } });
  };

  return (
    <span className="p-input-icon-left p-input-icon-right search-field">
      <InputText
        value={value}
        onChange={onChange}
        placeholder="Search..."
        className="search-input"
      />

      {value && <i className="pi pi-times clear-icon" onClick={handleClear} />}
    </span>
  );
}
